<template>
  <v-container class="my-12">
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("user.modulesbtn") }}</span>
    </v-tooltip>
    <base-material-card
      v-if="users"
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      class="px-5 py-3"
    >
      <v-card-title class="font-weight-bold">
        {{ $t("user.userList") }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('equipmentList.label-search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-btn
        @click="
          $router.push({
            name: 'Register'
          })
        "
        fab
        v-if="$store.getters['auth/adminAndUp']"
        color="#730D0B"
        absolute=""
        top
        right=""
        ><v-icon color="white">mdi-plus</v-icon></v-btn
      >
      <v-data-table
        loading-text="Loading... Please wait"
        :headers="headers"
        sort-by="dateCreated"
        sort-desc=""
        :items="users"
        :search="search"
        ><template v-slot:[`item.resume`]="{ item }">
          <v-icon
            :color="
              item.resume && item.resume.status.color
                ? item.resume.status.color
                : '#008450'
            "
            >mdi-circle</v-icon
          >
          {{
            item.resume.status && item.resume.status.name
              ? item.resume.status.name
              : $t("equipmentList.zones.smooth")
          }}
          {{ $t("equipmentList.zones.zone") }}
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <v-icon @click="deleteUser(item)" class="mr-4" color="error">
            mdi-trash-can
          </v-icon>
        </template>
        <template v-slot:[`item.dateCreated`]="{ item }">
          {{ item.dateCreated | FixingDate }}
        </template>
        <template v-slot:[`item.isMetax`]="{ item }">
          {{ item.isMetax ? "METAX" : "Customer" }}
        </template>
        <template v-slot:[`item.disable`]="{ item }">
          <v-icon
            @click="disableUser(item)"
            class="mr-4"
            :color="item.disable ? 'success' : 'primary'"
          >
            {{ item.disable ? "mdi-account" : "mdi-account-off" }}
          </v-icon>
        </template>

        <template v-slot:[`item.reset`]="{ item }">
          <v-icon @click="resetPassword(item)" color="blue"
            >mdi-lock-reset</v-icon
          >
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { auth } from "@/plugins/db";
export default {
  components: {},
  data() {
    return {
      search: null,
      headers: [
        {
          text: this.$t("user.firstName"),
          value: "firstName"
        },
        {
          text: this.$t("user.lastName"),
          value: "lastName"
        },
        {
          text: this.$t("user.email"),
          value: "email"
        },
        {
          text: this.$t("user.role"),
          value: "role"
        },

        {
          text: this.$t("user.company"),
          value: "isMetax"
        },
        { text: this.$t("user.date"), value: "dateCreated" },

        {
          text: this.$t("user.reset"),
          value: "reset",
          align: "center"
        },

        {
          text: this.$t("user.status"),
          value: "disable",
          align: "center"
        },

        {
          text: "Delete",
          sortable: false,
          align: "right",
          value: "delete"
        }
      ]
    };
  },

  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    try {
      await this.$store.dispatch("users/bindUsers");
      loading.close();
    } catch (error) {
      loading.close();
      this.$router.push("Error");
    }
  },
  computed: {
    ...mapState("users", ["users"])
  },
  methods: {
    async deleteUser(item) {
      var res;
      res = await this.$dialog.warning({
        text: "Do you really want to delete this user?",
        title: "Warning",
        icon: "mdi-alert"
      });
      if (res == true) {
        await this.$store.dispatch("auth/DELETE_USER", item.id);
        this.$dialog.notify.info("User has been deleted", {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-email"
        });
      }
    },
    async resetPassword(item) {
      try {
        await auth.sendPasswordResetEmail(item.email);
        this.$dialog.notify.info("User password reset has been sent", {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-email"
        });
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-email"
        });
      }
    },
    async disableUser(item) {
      var res;
      if (item.disable) {
        res = await this.$dialog.warning({
          text: "Do you really want to unpause this user?",
          title: "Warning",
          icon: "mdi-alert"
        });
      } else {
        res = await this.$dialog.warning({
          text: "Do you really want to pause this user?",
          title: "Warning",
          icon: "mdi-alert"
        });
      }

      if (res == true) {
        let payload = {
          id: item.id,
          disable: item.disable || false
        };
        await this.$store.dispatch("users/toggleUser", payload);
        this.$dialog.notify.info("User has been updated", {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-email"
        });
      }
    }
  },

  filters: {
    FixingDate: function(value) {
      if (value) {
        return moment.unix(value.seconds).format("MMMM D YYYY, h:mm:ss a");
      } else {
        return null;
      }
    }
  }
};
</script>
<style scoped>
th {
  vertical-align: middle !important;
}
</style>
